import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImageWithSource} from '../../models/floor-plan-editor-view';

@Component({
  selector: 'awair-floor-plan-image-empty',
  templateUrl: './floor-plan-image-empty.component.html',
  styleUrls: ['./floor-plan-image-empty.component.scss']
})

export class FloorPlanImageEmptyComponent implements OnInit {

  @Input() selectedFloorId: string;
  @Output() fileUpload: EventEmitter<ImageWithSource> = new EventEmitter<ImageWithSource>();

  constructor() {
  }

  ngOnInit() {
  }

  onFileUpload(imageWithSource: ImageWithSource): void {
    this.fileUpload.emit(imageWithSource);
  }
}
